import ActivityWrapper from '~/bootcamp/Activities/components/ActivityWrapper'
import SelectionButton from '~/bootcamp/Activities/components/SelectionButton'
import { ActivityProps } from '~/bootcamp/Activities/types/activities.types'
import AlgebraActivityWrapper from '~/bootcamp/Activities/Algebra/Components/AlgebraActivityWrapper'
import { useEmitInstance } from '~/bootcamp/Activities/utils/instance.utils'

import useWhatAlgebra from './useWhatAlgebra'
import { EquationType } from './WhatAlgebra.utils'

/** Strips markup and normalizes × to \cdot; the emit must not carry HTML. */
const plainEquation = (equation: string): string =>
  equation
    .replace(/<[^>]+>/g, '')
    .replace(/×/g, '\\cdot')
    .replace(/\s+/g, ' ')
    .trim()

function WhatAlgebra({
  answerState,
  actionButtonsFC,
  onAnswerStateChange,
  onInstanceChange,
  onNextQuestionClick,
}: ActivityProps): React.ReactElement {
  const { options, formValid, answer, onInputChange, handleCheckAnswer, goToNextQuestion } = useWhatAlgebra({
    onAnswerStateChange,
    onNextQuestionClick,
  })

  // EquationType (the answer) never rides the emit.
  useEmitInstance(
    onInstanceChange,
    options?.length ? `options: ${options.map(({ equation }) => plainEquation(equation)).join('; ')}` : null,
  )

  return (
    <ActivityWrapper>
      <AlgebraActivityWrapper>
        <div className="flex flex-wrap justify-around">
          {options &&
            options.map(({ equation, type }, index) => (
              <div className="flex-1/2 p-2" key={`${equation}`}>
                <SelectionButton
                  className="p-2 w-full h-20 flex justify-center items-center"
                  isSelected={answer[index]}
                  isWrong={
                    answerState === false &&
                    ((answer[index] === true && type === EquationType.NonAlgebraic) ||
                      (answer[index] !== true && type === EquationType.Algebraic))
                  }
                  key={`${equation}`}
                  onClick={onInputChange.bind(null, index)}
                >
                  <span dangerouslySetInnerHTML={{ __html: equation }} />
                </SelectionButton>
              </div>
            ))}
        </div>
      </AlgebraActivityWrapper>
      {actionButtonsFC &&
        actionButtonsFC({
          formValid,
          correctAnswer: answerState ?? false,
          submitAnswerAction: handleCheckAnswer,
          clearFormAction: () => onInputChange(),
          goToNextQuestionAction: goToNextQuestion,
        })}
    </ActivityWrapper>
  )
}

export default WhatAlgebra
